import axios from "axios";
import { API } from "@/lib/api";

// Separate axios instance + localStorage key from lib/api.js's staff client, so an
// admin/sub-admin and a client account can be signed in simultaneously in the same
// browser without their tokens colliding.
const clientApi = axios.create({ baseURL: API });

clientApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("eazy_client_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default clientApi;
